import axios from 'axios';

import type {
  ClaimMilestoneDefinitionCreateJson,
  ClaimMilestoneDefinitionModel,
  ClaimMilestoneDefinitionUpdateJson,
} from '~/server_shared/openapi/data-contracts';

// The definitions are read from the non-sysconfig API; only the writes are sysconfig routes.
export const getClaimMilestoneDefinitionsUrl = (organizationId: number) =>
  `/api/v1/organizations/${organizationId}/claim_milestone/config`;

const getBaseUrl = (organizationId: number) => `/sysconfig/api/v1/organizations/${organizationId}/claim_milestone`;

// The claim fields a milestone's conditions may use, for the scope passed as query params.
export const getClaimMilestoneConditionFieldsUrl = (organizationId: number) =>
  `${getBaseUrl(organizationId)}/condition_fields`;

export const createClaimMilestoneDefinition = async (
  organizationId: number,
  values: ClaimMilestoneDefinitionCreateJson
): Promise<ClaimMilestoneDefinitionModel> => {
  const url = getBaseUrl(organizationId);
  const response = await axios.post<ClaimMilestoneDefinitionModel>(url, values);
  return response.data;
};

export const updateClaimMilestoneDefinition = async (
  organizationId: number,
  milestoneKey: string,
  updates: ClaimMilestoneDefinitionUpdateJson
): Promise<ClaimMilestoneDefinitionModel> => {
  const url = `${getBaseUrl(organizationId)}/${milestoneKey}`;
  const response = await axios.patch<ClaimMilestoneDefinitionModel>(url, updates);
  return response.data;
};

// One atomic reorder: the full ordered key list replaces the stored order in a single call.
export const reorderClaimMilestoneDefinitions = async (
  organizationId: number,
  milestoneKeys: string[]
): Promise<void> => {
  const url = `${getBaseUrl(organizationId)}/order`;
  await axios.put<void>(url, { milestone_keys: milestoneKeys });
};
